import {h, Fragment} from "preact"
import { useResponse, AutocompleteElement, Keywords, useCurrencyFormatting, useAppState } from "@nosto/preact"
import { productImagePlaceholder } from "../helpers"
import { useEffect, useMemo, useState } from "preact/hooks"
import SubmitButton from "./elements/SubmitButton"

export default function Autocomplete() {
    const { products, keywords } = useResponse()
    const { query } = useAppState()
    const { format } = useCurrencyFormatting()
    const locale = useMemo(() => window.Shopify?.routes?.root ?? "/", []);

    if (!products?.hits?.length && !keywords?.hits?.length) {
        return
    }
    
    // const input = document.querySelector('.Search__SearchBar:not(.mobile_only) .Search__Input.Heading')

    // useState(() =>{
    //     console.log(input.value.length)
    //     if(input.value != ""){
    //         document.querySelector('.floated-header-wrapper .inner-wrapper').classList.add('max-width-60')     
    //     }else{
    //         document.querySelector('.floated-header-wrapper .inner-wrapper').classList.remove('max-width-60')
    //     }
    // },[input.value.length])

    // useEffect(() => {
    //     const inputElement = document.querySelector('.Search__SearchBar:not(.mobile_only) .Search__Input.Heading');
    //     const innerWrapper = document.querySelector('.floated-header-wrapper .inner-wrapper');
    
    //     if (!inputElement || !innerWrapper) return;
    
    //     let hasValue = false;
    
    //     function toggleBodyClass() {
    //       if (hasValue) {
    //         innerWrapper.classList.add('max-width-60');
    //       } else {
    //         innerWrapper.classList.remove('max-width-60');
    //       }
    //     }
    
    //     function handleInput() {
    //       hasValue = inputElement.value.length > 1;
    //       toggleBodyClass();
    //     }
    
    //     inputElement.addEventListener('input', handleInput);
    
    //     // Cleanup event listener on component unmount
    //     return () => {
    //       inputElement.removeEventListener('input', handleInput);
    //     };
    //   }, []);

    useEffect(() => {
        if(!window.Nosto?.migrateToShopifyMarket) return;
        window.Nosto.migrateToShopifyMarket({
            productSectionElement: '.ns-autocomplete-shopify-markets',
            productHandleAttribute: 'data-handle',
            productUrlElement: '.ns-placeholder-link',
            priceElement: '.ProductItem__Price',
        }).then(() => {
            document.querySelectorAll('.ns-autocomplete .ns-autocomplete-shopify-markets').forEach(el => {
                el.classList.remove('.ns-autocomplete-shopify-markets');
                const priceEl = el.querySelector('.ProductItem__Price');
                if(priceEl && priceEl.textContent?.endsWith(".00")) {
                    priceEl.textContent = priceEl.textContent.slice(0, -3);
                }
            })
        });
    }, [ products?.hits ])

    return (
        <div
            class="ns-autocomplete ns-absolute ns-d-flex ns-flex-column ns-flex-sm-row ns-align-items-start  ns-border-box"
            data-nosto-element="autocomplete"
        >
            <div class="ns-autocomplete-wrapper ns-background-white ns-w-100 ns-mt-sm-auto">
                <div class="ns-autocomplete-results ns-d-flex ns-flex-column">
                    {keywords?.hits?.length > 0 && (
                        <div
                            class={`ns-autocomplete-keywords ns-d-flex ns-flex-column ns-col-12`}
                        >
                            <div class="ns-color-black ns-autocomplete-suggestions-title ns-font-4">
                                Suggestions
                            </div>
                            <div class="ns-d-flex ns-flex-column">
                                {keywords?.hits?.map((hit) => (
                                    <AutocompleteElement  
                                        hit={{
                                            ...hit,
                                            ...(hit._redirect && {
                                                _redirect: hit._redirect.replace('.com', `.com${locale.slice(0, -1)}`)
                                            })
                                        }} 
                                        key={hit.keyword}
                                    >
                                        <div class="ns-autocomplete-suggestions" style="cursor: pointer;">
                                            {hit._highlight.keyword ? (
                                                <span dangerouslySetInnerHTML={{ __html: hit._highlight.keyword }}></span>
                                            ) : (
                                                <span>{hit.keyword}</span>
                                            )}
                                            <svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" width="18" height="18" x="0" y="0" viewBox="0 0 64 64" style="enable-background:new 0 0 512 512" xml:space="preserve" class="">
                                                <g>
                                                    <path d="M54 30H14.101l15.278-14.552a2 2 0 1 0-2.759-2.897L9.172 29.171A3.978 3.978 0 0 0 8 32c0 1.068.417 2.073 1.207 2.862l17.414 16.586c.387.369.883.552 1.379.552a1.999 1.999 0 0 0 1.38-3.448L14.038 34H54a2 2 0 0 0 0-4z" fill="#000000" opacity="1" data-original="#000000"></path>
                                                </g>
                                            </svg>
                                        </div>
                                       
                                    </AutocompleteElement>
                                ))}
                            </div>
                            {!products?.hits?.length && <SubmitButton text="See all search results" />}
                        </div>
                    )}
                    {products?.hits?.length > 0 && (
                        <div class="ns-autocomplete-products ns-d-flex ns-flex-column ns-flex-grow-1">
                            <div class="ns-color-black ns-autocomplete-suggestions-title ns-font-4">
                                Recommended Products
                                <SubmitButton text="View All Results" />
                            </div>
                            <div class="ns-autocomplete-prod-list ns-d-flex ns-flex-row">
                                {products?.hits?.map(hit => {
                                    return (
                                        <AutocompleteElement 
                                            hit={{
                                                productId: hit.productId,
                                                url: hit.url.replace('/products/', `${locale}products/`),
                                            }} 
                                            key={hit.productId}
                                        >
                                            <div 
                                                class="ns-autocomplete-shopify-markets" 
                                                data-handle={hit.url.split('/products/')[1]}
                                            >
                                                <div
                                                    data-url={hit.url.replace('/products/', `${locale}products/`)}
                                                    class="ns-autocomplete-product-wrapper ns-d-flex ns-flex-column ns-clickable ns-h-100"
                                                    data-nosto-element="product"
                                                >
                                                    <a href="javascript:void(0)" class="ns-image-wrapper">
                                                        <img
                                                            class="ns-h-100 ns-w-100"
                                                            src={hit.imageUrl ?? productImagePlaceholder}
                                                            alt={hit.name}
                                                        />
                                                    </a>
                                                    <div class="ns-product-name-results">{hit.name}</div>
                                                    <span class="ProductItem__Price Price Text--subdued ns-product-suggestion-price">{format(hit.price)}</span>  
                                                </div>
                                                {/* avoid errors with markets */}
                                                <a class="ns-placeholder-link" href={hit.url} style="display: none;">{hit.name}</a>
                                            </div>
                                        </AutocompleteElement>
                                    )
                                })}
                            </div>
                            
                        </div>
                    )}
                </div>
            </div>
        </div>
    )
}